<div class="wt-input-checkbox"
     [class.wt-input-checkbox--disabled]="disabled"
     [ngClass]="additionalClasses"
>
  <input class="wt-form-checkbox" type="checkbox"
         [id]="id"
         [disabled]="disabled"
         [(ngModel)]="value"
         (click)="clicked.emit()"
  >
  <label class="wt-input-checkbox__label"
         [for]="id"
  >
    <ng-content></ng-content>
  </label>
</div>

